<!-- eslint-disable @angular-eslint/template/no-call-expression -->
<div class="row">
  <div (click)="showMe = !showMe" class="d-flex flex-grow justify-content-between cursor-pointer no-select">
    <h3 class="zero-text p-base-med">{{ 'user-self-service.my-data.headline' | transloco }}</h3>
    <web-design-system-icon name="chevron" [class.icon-rotate]="!showMe" />
  </div>
</div>
<div class="row opacity-container" [class.active]="showMe">
  <div class="pl-0 col-12 mt-3">
    <div class="row align-items-center">
      <div class="col-11">
        <h4 class="zero-text p-small-bold">{{ 'user-self-service.my-data.address.headline' | transloco }}</h4>
      </div>
      <div class="col-1 text-right pr-1">
        <button
          class="btn btn-link p-0"
          (click)="editMode = !editMode"
          [ngbTooltip]="editMode ? 'Abbrechen' : 'Bearbeiten'"
          [openDelay]="500"
          placement="bottom"
        >
          <web-design-system-icon name="edit" />
        </button>
      </div>
      <div class="col-12 col-sm-4">{{ 'user-self-service.my-data.address.name' | transloco }}</div>
      <div class="col-12 col-sm-8">
        {{ currentCustomer.firstName + ' ' + currentCustomer.lastName }}
      </div>
      <div class="col-12 col-sm-4">{{ 'user-self-service.my-data.address.street+number' | transloco }}</div>
      <div class="col-12 col-sm-8">
        {{ customerBaseData?.street1 + ' ' + customerBaseData?.streetNr }}
      </div>
      @if (customerBaseData?.additionalAddress) {
        <div class="col-12 col-sm-4">{{ 'user-self-service.my-data.address.street2' | transloco }}</div>
        <div class="col-12 col-sm-8">{{ customerBaseData?.additionalAddress }}</div>
      }
      <div class="col-12 col-sm-4">{{ 'user-self-service.my-data.address.zip+city' | transloco }}</div>
      <div class="col-12 col-sm-8">
        {{ customerBaseData?.postalCode + ' ' + customerBaseData?.city }}
      </div>
    </div>
  </div>
  @if (hasOpenTicket$ | async) {
    <div class="col-12 d-flex mt-3 mb-3 pl-0">
      <web-design-system-button size="small" [disabled]="true">
        {{ 'user-self-service.my-data.address.update-in-progress' | transloco }}
      </web-design-system-button>
    </div>
  }

  @if (editMode) {
    <div class="pl-0 col-12">
      <hr />
    </div>
  }
  @if (editMode) {
    <div class="pl-0 col-12 mb-2">
      <h4 class="zero-text p-small-bold">{{ 'user-self-service.my-data.address.new' | transloco }}</h4>
    </div>
  }

  @if (editMode) {
    <form (ngSubmit)="onSubmit(f)" #f="ngForm" class="pl-0 col-12">
      <div class="row">
        <div class="col-12 col-sm-6">
          <div
            class="input-group-material margin-top-15"
            [class.input-group-material--error]="!strasseInputVar.value && strasseInputVar.touched"
          >
            <input
              type="text"
              required
              [(ngModel)]="editData[ATTR_NEW_STREET]"
              name="strasseInput"
              id="strasseInput"
              pattern="^(?!([0-9])).+$"
              #strasseInputVar="ngModel"
              [class.empty]="!strasseInputVar.value"
            />
            <div class="input-group-material-icon-state"></div>
            <label for="strasseInput"> {{ 'user-self-service.my-data.address.street' | transloco }} </label>
            @if (strasseInputVar.valid) {
              <div class="input-group-material-message">&nbsp;</div>
            }
            @if (!strasseInputVar.value) {
              <div class="input-group-material-message">{{ 'user-self-service.my-data.address.input-required' | transloco }}</div>
            }
            @if (strasseInputVar.errors && strasseInputVar.errors['pattern']) {
              <div class="input-group-material-message">{{ 'user-self-service.my-data.address.input-required-error' | transloco }}</div>
            }
          </div>
        </div>
        <div class="col-12 col-sm-6">
          <div
            class="input-group-material margin-top-15"
            [class.input-group-material--error]="!hausnummerInputVar.value && hausnummerInputVar.touched"
          >
            <input
              type="text"
              required
              [(ngModel)]="editData[ATTR_NEW_STREETNO]"
              name="hausnummerInput"
              id="hausnummerInput"
              pattern="^[0-9]+.*$"
              #hausnummerInputVar="ngModel"
              [class.empty]="!hausnummerInputVar.value"
            />
            <div class="input-group-material-icon-state"></div>
            <label for="hausnummerInput"> {{ 'user-self-service.my-data.address.house-number' | transloco }} </label>
            @if (hausnummerInputVar.valid) {
              <div class="input-group-material-message">&nbsp;</div>
            }
            @if (!hausnummerInputVar.value) {
              <div class="input-group-material-message">{{ 'user-self-service.my-data.address.input-required' | transloco }}</div>
            }
            @if (hausnummerInputVar.errors && hausnummerInputVar.errors['pattern']) {
              <div class="input-group-material-message">{{ 'user-self-service.my-data.address.input-required-error' | transloco }}</div>
            }
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="input-group-material margin-top-15">
            <input
              type="text"
              [(ngModel)]="editData[ATTR_NEW_STREET2]"
              name="adresszusatzInput"
              id="adresszusatzInput"
              #adresszusatzInputVar="ngModel"
              [class.empty]="!adresszusatzInputVar.value"
            />
            <div class="input-group-material-icon-state"></div>
            <label for="adresszusatzInput"> {{ 'user-self-service.my-data.address.street-addition' | transloco }} </label>
            <div class="input-group-material-message">&nbsp;</div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-sm-6">
          <div class="input-group-material margin-top-15" [class.input-group-material--error]="!plzInputVar.value && plzInputVar.touched">
            <input
              type="text"
              required
              [(ngModel)]="editData[ATTR_NEW_POSTALCODE]"
              name="plzInput"
              id="plzInput"
              [pattern]="postCodeValidationPattern()"
              #plzInputVar="ngModel"
              [class.empty]="!plzInputVar.value"
            />
            <div class="input-group-material-icon-state"></div>
            <label for="plzInput"> {{ 'user-self-service.my-data.address.zip' | transloco }} </label>
            @if (plzInputVar.valid) {
              <div class="input-group-material-message">&nbsp;</div>
            }
            @if (!plzInputVar.value) {
              <div class="input-group-material-message">{{ 'user-self-service.my-data.address.input-required' | transloco }}</div>
            }
            @if (plzInputVar.errors && plzInputVar.errors['pattern']) {
              <div class="input-group-material-message">{{ 'user-self-service.my-data.address.input-required-error' | transloco }}</div>
            }
          </div>
        </div>
        <div class="col-12 col-sm-6">
          <div class="input-group-material margin-top-15" [class.input-group-material--error]="!ortInputVar.value && ortInputVar.touched">
            <input
              type="text"
              required
              [(ngModel)]="editData[ATTR_NEW_CITY]"
              name="ortInput"
              id="ortInput"
              minlength="2"
              pattern="^(?!([0-9])).+$"
              #ortInputVar="ngModel"
              [class.empty]="!ortInputVar.value"
            />
            <div class="input-group-material-icon-state"></div>
            <label for="ortInput"> {{ 'user-self-service.my-data.address.city' | transloco }} </label>
            @if (ortInputVar.valid) {
              <div class="input-group-material-message">&nbsp;</div>
            }
            @if (!ortInputVar.value) {
              <div class="input-group-material-message">{{ 'user-self-service.my-data.address.input-required' | transloco }}</div>
            }
            @if (ortInputVar.errors && (ortInputVar.errors['pattern'] || ortInputVar.errors['minlength'])) {
              <div class="input-group-material-message">{{ 'user-self-service.my-data.address.input-required-error' | transloco }}</div>
            }
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-sm-6">
          <div
            class="input-group-material select-dropdown margin-top-15"
            [class.input-group-material--error]="!landSelectVar.value && landSelectVar.touched"
          >
            <select
              [(ngModel)]="editData[ATTR_NEW_COUNTRY]"
              name="landSelect"
              id="landSelect"
              #landSelectVar="ngModel"
              [class.empty]="!landSelectVar.value"
              required
            >
              @for (cVal of countriesService.allIsoCodesSortedByDisplayName; track $index) {
                <option [value]="cVal">
                  {{ countriesService.allIsoCountriesEnum[cVal] }}
                </option>
              }
            </select>
            <label for="landSelect"> {{ 'user-self-service.my-data.address.country' | transloco }} </label>
            @if (landSelectVar.valid) {
              <div class="input-group-material-message">&nbsp;</div>
            }
            @if (!landSelectVar.value) {
              <div class="input-group-material-message">{{ 'user-self-service.my-data.address.input-required' | transloco }}</div>
            }
          </div>
        </div>
      </div>
      <div class="row">
        @if (!verificationMode) {
          <div class="col-12 d-flex margin-top-15 margin-bottom-15 justify-content-between">
            <span class="text-color-primary"> {{ 'user-self-service.my-data.address.tin-explanation' | transloco }} </span>
          </div>
        }
      </div>
      <div class="row">
        <div class="col-12 col-sm-6">
          <div class="input-group-material select-dropdown margin-top-15">
            <select
              [(ngModel)]="editData[ATTR_NEW_TAX_COUNTRY_1]"
              name="steuerlandSelect"
              id="steuerlandSelect"
              #steuerlandSelectVar="ngModel"
              [class.empty]="!steuerlandSelectVar.value"
              [required]="editData[ATTR_NEW_COUNTRY] !== 'DE'"
            >
              @for (cVal of countriesService.allIsoCodesSortedByDisplayName; track $index) {
                <option [value]="cVal">
                  {{ countriesService.allIsoCountriesEnum[cVal] }}
                </option>
              }
            </select>
            <label for="steuerlandSelect"> {{ 'user-self-service.my-data.address.first-country' | transloco }} </label>
            @if (steuerlandSelectVar.valid) {
              <div class="input-group-material-message">&nbsp;</div>
            }
            @if (!steuerlandSelectVar.value) {
              <div class="input-group-material-message">{{ 'user-self-service.my-data.address.input-required' | transloco }}</div>
            }
          </div>
        </div>
        <div class="col-12 col-sm-6">
          <div
            class="input-group-material margin-top-15"
            [class.input-group-material--error]="
              (!steueridInputVar.value && steueridInputVar.touched) || (steueridInputVar.value && steueridInputVar.errors)
            "
          >
            <input
              type="text"
              [required]="editData[ATTR_NEW_TAX_COUNTRY_1] && editData[ATTR_NEW_TAX_COUNTRY_1] !== ''"
              [disabled]="!editData[ATTR_NEW_TAX_COUNTRY_1] || editData[ATTR_NEW_TAX_COUNTRY_1] === ''"
              [(ngModel)]="editData[ATTR_NEW_TAX_ID_1]"
              name="steueridInput"
              id="steueridInput"
              formValidatorsTinValidator
              [countryCode]="editData[ATTR_NEW_TAX_COUNTRY_1]"
              #steueridInputVar="ngModel"
              [class.empty]="!steueridInputVar.value"
            />
            <div class="input-group-material-icon-state"></div>
            <label for="steueridInput"> {{ 'user-self-service.my-data.address.tin' | transloco }} </label>
            @if (steueridInputVar.valid) {
              <div class="input-group-material-message">&nbsp;</div>
            }
            @if (steueridInputVar.errors && steueridInputVar.errors['invalidGermanTin']) {
              <div class="input-group-material-message">
                {{ steueridInputVar.getError('invalidGermanTin') }}
              </div>
            }
          </div>
        </div>
      </div>
      <div class="row margin-top-30 margin-bottom-30">
        <div class="col-12 col-sm-6">
          <a (click)="showWeitere = true" class="link-underline cursor-pointer">
            {{ 'user-self-service.my-data.address.other-tax-residences' | transloco }}
          </a>
        </div>
      </div>
      @if (showWeitere) {
        <span>
          <div class="row">
            <div class="col-12 col-sm-5">
              <div
                class="input-group-material select-dropdown margin-top-15"
                [class.input-group-material--error]="steuerland2SelectVar.errors && steuerland2SelectVar.touched"
              >
                <select
                  [(ngModel)]="editData[ATTR_NEW_TAX_COUNTRY_2]"
                  name="steuerland2Select"
                  id="steuerland2Select"
                  #steuerland2SelectVar="ngModel"
                  [class.empty]="!steuerland2SelectVar.value"
                  [required]="steuerid2InputVar.value"
                >
                  @for (cVal of countriesService.allIsoCodesSortedByDisplayName; track $index) {
                    <option [value]="cVal">
                      {{ countriesService.allIsoCountriesEnum[cVal] }}
                    </option>
                  }
                </select>
                <label for="steuerland2Select"> {{ 'user-self-service.my-data.address.second-country' | transloco }} </label>
                @if (!steuerland2SelectVar.value) {
                  <div class="input-group-material-message">{{ 'user-self-service.my-data.address.input-required' | transloco }}</div>
                }
              </div>
            </div>
            <div class="col-12 col-sm-6">
              <div
                class="input-group-material margin-top-15"
                [class.input-group-material--error]="(!steuerid2InputVar.value || steuerid2InputVar.errors) && steuerid2InputVar.touched"
              >
                <input
                  type="text"
                  [required]="steuerland2SelectVar.value"
                  [(ngModel)]="editData[ATTR_NEW_TAX_ID_2]"
                  name="steuerid2Input"
                  id="steuerid2Input"
                  formValidatorsTinValidator
                  [countryCode]="steuerland2SelectVar.value"
                  #steuerid2InputVar="ngModel"
                  [class.empty]="!steuerid2InputVar.value"
                />
                <div class="input-group-material-icon-state"></div>
                <label for="steuerid2Input"> {{ 'user-self-service.my-data.address.tin' | transloco }} </label>
                @if (steuerid2InputVar.errors && steuerid2InputVar.errors['invalidGermanTin']) {
                  <div class="input-group-material-message">
                    {{ steuerid2InputVar.getError('invalidGermanTin') }}
                  </div>
                }
                @if (steuerid2InputVar.errors && steuerid2InputVar.errors['invalidLength']) {
                  <div class="input-group-material-message">{{ 'user-self-service.my-data.address.input-tin-text' | transloco }}</div>
                }
              </div>
            </div>
            <div class="col-12 col-sm-1 margin-top-20">
              <div class="icon icon-24 cursor-pointer" (click)="deleteRow(2)">
                <svg>
                  <use class="icon-trashcan" xlink:href="/assets/img/svgs/svgset.svg#trashcan" />
                </svg>
              </div>
            </div>
          </div>
          @if (
            (steuerid2InputVar.value !== null && steuerid2InputVar.valid) ||
            (editData['ATTR_NEW_TAX_COUNTRY_3'] !== null && editData['ATTR_NEW_TAX_COUNTRY_3'] !== '')
          ) {
            <div class="row">
              <div class="col-12 col-sm-5">
                <div
                  class="input-group-material select-dropdown margin-top-15"
                  [class.input-group-material--error]="steuerland3SelectVar.errors && steuerland3SelectVar.touched"
                >
                  <select
                    [(ngModel)]="editData[ATTR_NEW_TAX_COUNTRY_3]"
                    name="steuerland3Select"
                    id="steuerland3Select"
                    [required]="steuerid3InputVar.value"
                    #steuerland3SelectVar="ngModel"
                    [class.empty]="!steuerland3SelectVar.value"
                  >
                    @for (cVal of countriesService.allIsoCodesSortedByDisplayName; track $index) {
                      <option [value]="cVal">
                        {{ countriesService.allIsoCountriesEnum[cVal] }}
                      </option>
                    }
                  </select>
                  <label for="steuerland3Select"> {{ 'user-self-service.my-data.address.thirt-country' | transloco }} </label>
                  @if (!steuerland3SelectVar.value) {
                    <div class="input-group-material-message">{{ 'user-self-service.my-data.address.input-required' | transloco }}</div>
                  }
                </div>
              </div>
              <div class="col-12 col-sm-6">
                <div
                  class="input-group-material margin-top-15"
                  [class.input-group-material--error]="steuerid3InputVar.errors && steuerid3InputVar.touched"
                >
                  <input
                    type="text"
                    [required]="steuerland3SelectVar.value"
                    [(ngModel)]="editData[ATTR_NEW_TAX_ID_3]"
                    name="steuerid3Input"
                    id="steuerid3Input"
                    formValidatorsTinValidator
                    [countryCode]="steuerland3SelectVar.value"
                    #steuerid3InputVar="ngModel"
                    [class.empty]="!steuerid3InputVar.value"
                  />
                  <div class="input-group-material-icon-state"></div>
                  <label for="steuerid3Input"> {{ 'user-self-service.my-data.address.tin' | transloco }} </label>
                  @if (steuerid3InputVar.errors && steuerid3InputVar.errors['invalidGermanTin']) {
                    <div class="input-group-material-message">
                      {{ steuerid3InputVar.getError('invalidGermanTin') }}
                    </div>
                  }
                  @if (steuerid3InputVar.errors && steuerid3InputVar.errors['invalidLength']) {
                    <div class="input-group-material-message">{{ 'user-self-service.my-data.address.input-tin-text' | transloco }}</div>
                  }
                </div>
              </div>
              <div class="col-12 col-sm-1 margin-top-20">
                <div class="icon icon-24 cursor-pointer" (click)="deleteRow(3)">
                  <svg>
                    <use class="icon-trashcan" xlink:href="/assets/img/svgs/svgset.svg#trashcan" />
                  </svg>
                </div>
              </div>
            </div>
          }
        </span>
      }
      <div class="row">
        @if (!verificationMode) {
          <div class="col-12 d-flex flex-column mt-3 mb-3">
            {{ 'user-self-service.my-data.address.authorize-changes-request' | transloco }}
            <div class="mt-2">
              <web-design-system-button [isSubmit]="true" [disabled]="!f.valid" size="small">
                {{ 'user-self-service.my-data.address.next-button-text' | transloco }}
              </web-design-system-button>
            </div>
          </div>
        }
      </div>
    </form>
    <div class="pl-0 col-12 mt-2">
      <web-components-user-messages />
    </div>
  }
  @if (verificationMode) {
    <div class="pl-0 col-12 d-flex">
      <web-components-transaction-auth [payload]="dataToAuthorize" (transactionResult)="authorizedTransactionResult($event)" />
    </div>
    <div class="pl-0 col-12 mt-2">
      <web-components-user-messages />
    </div>
  }

  <div class="pl-0 col-12 mt-4 margin-bottom-15">
    <div class="row">
      <div class="col-12">
        <h4 class="zero-text p-small-bold">{{ 'user-self-service.my-data.contact-data.headline' | transloco }}</h4>
      </div>

      <div class="col-12">
        <self-service-user-contact-data-email [currentUser]="currentUser" />
      </div>

      <div class="col-12 col-sm-4">{{ 'user-self-service.my-data.contact-data.phone' | transloco }}</div>
      <div class="col-12 col-sm-8">
        {{ customerBaseData?.phone1 ? customerBaseData?.phone1 : '-' }}
      </div>
      <div class="col-12 col-sm-4">{{ 'user-self-service.my-data.contact-data.mobile' | transloco }}</div>
      <div class="col-12 col-sm-8">
        <span>{{ currentUser?.mobilenr }}</span>
        <span
          class="icon icon-18 align-content-center margin-left-10"
          [ngClass]="currentUser?.mobilenr && currentUser?.mobilenrVerified ? 'haken' : 'cross'"
        ></span>
        <br />
        <span> {{ 'user-self-service.my-data.contact-data.go-to-text' | transloco }} </span>
      </div>
    </div>
  </div>
  <div class="pl-0 col-12 margin-top-15 margin-bottom-15">
    <div class="row">
      <div class="col-12">
        <h4 class="zero-text p-small-bold">{{ 'user-self-service.my-data.account-use.headline' | transloco }}</h4>
      </div>
      <div class="col-12 col-sm-4">{{ 'user-self-service.my-data.account-use.use' | transloco }}</div>
      <div class="col-12 col-sm-8">{{ 'user-self-service.my-data.account-use.private' | transloco }}</div>
      <div class="col-12 col-sm-4">{{ 'user-self-service.my-data.account-use.next' | transloco }}</div>
      <div class="col-12 col-sm-8">{{ 'user-self-service.my-data.account-use.conform-text' | transloco }}</div>
    </div>
  </div>

  <div class="pl-0 col-12 margin-top-15 margin-bottom-15">
    <div class="row align-items-center">
      <div class="col-11">
        <h4 class="zero-text p-small-bold">{{ 'user-self-service.my-data.identification-document.headline' | transloco }}</h4>
      </div>
      <div class="col-1 text-right pr-1">
        <button class="btn btn-link p-0" (click)="startUpdateIdentDoc()" [ngbTooltip]="'Bearbeiten'" [openDelay]="500" placement="bottom">
          <web-design-system-icon name="edit" />
        </button>
      </div>
    </div>
    <div class="row mb-2">
      <div class="col-12 col-sm-4">{{ 'user-self-service.my-data.identification-document.validity' | transloco }}</div>
      @if (customerBaseData?.identDocValidUntil) {
        <div class="col-12 col-sm-8">bis {{ customerBaseData?.identDocValidUntil | date: 'dd.MM.yyyy' }}</div>
      }
      @if (customerBaseData && !customerBaseData.identDocValid && customerBaseData.identDocValidUntil) {
        <div class="col-12 col-sm-8 text-danger">
          {{ 'user-self-service.my-data.identification-document.identification-expired' | transloco }}
        </div>
      }
    </div>

    @if (updateIdentDocMode) {
      <self-service-update-identdoc (updateResult)="updateIdentDocFinished($event)" />
    }

    @if (updateIdentDocResult) {
      <div class="row mt-2">
        <div class="col-12">
          {{ updateIdentDocResult }}
        </div>
      </div>
    }
  </div>

  <div class="pl-0 col-12 mt-4">
    <div class="row">
      <div class="col-12 mb-3">
        <h4 class="zero-text p-small-bold">{{ 'user-self-service.my-data.accept-data.headline' | transloco }}</h4>
      </div>
      <div class="col-12">
        <web-design-system-switch
          [label]="'user-self-service.my-data.accept-data.paragraph' | transloco"
          [checked]="adAgree"
          (checkedChange)="changeAdAgree()"
        />
      </div>
    </div>
  </div>
</div>
